import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import Access from "./components/Access";
import Navbar from "./components/Navbar";
import IncidencesFinancieres from "./components/IncidencesFinancieres";
import GanttSyntheseProjets from "./components/GanttSyntheseProjets";
import { addSpace, rescueHtml } from "./components/Tools";
import {NotificationManager} from 'react-notifications';
import { ReactComponent as Trash } from './Img/icon-trash.svg';
import { useHistory } from 'react-router-dom';
import { ReactComponent as Add } from './Img/icon-add.svg';
import Dialog from "./components/Dialog";
import ModalGestionPPR from "./components/ModalGestionPPR";


/*
    La variable ListeProjets contient toutes les infos du projet et est structurée ainsi:
    projet[0] = id
    projet[1] = id_budget
    projet[2] = numero_projet
    projet[3] = nom
    projet[4] = enjeu
    projet[5] = priorite
    projet[6] = priorite_niveau
    projet[7] = pol_pub_rat (politique publique de rattachement)
    projet[8] = referent_elu
    projet[9] = montant
    projet[10] = description
    projet[11] = remarques
    projet[12] = maitre_ouvrage
    projet[13] = partenaire_mobiliser
    projet[14] = service_referent
    projet[15] = technicien_ref_nom
    projet[16] = technicien_ref_fonction
    projet[17] = technicien_ref_telephone
    projet[18] = technicien_ref_mail
    projet[19] = ressources_humaines
    projet[20] = etudes
    projet[21] = outils
    projet[22] = investissements
    projet[23] = incidences_organisationnelle_administrative
    projet[24] = h1
    projet[25] = h2
    projet[26] = h3
    projet[27] = couleur
    projet[28] = prerequis
    projet[29] = etapes_prog
    projet[30] = description_objectifs
    projet[31] = note_evaluation
    projet[32] = ajustement_objectifs
    projet[33] = niveau_atteinte_objectifs
    projet[34] = id_users_droits_visu
    projet[35] = id_users_droits_modif
*/


const FichesProjets = (props) =>
{
    let history = useHistory();
    const timestamp = new Date().getTime();
    const [idSelected, setIdSelected] = useState(null);
    const [listeProjets, setListeProjets] = useState([]);
    const [annees, setAnnees] = useState([]);
    const [ongletListeProjets, setOngletListeProjets] = useState(true);
    const [ongletIncidencesFinancieres, setOngletIncidencesFinancieres] = useState(false);
    const [ongletSyntheseGantt, setOngletSyntheseGantt] = useState(false);
    const [listeppr, setListeppr] = useState([]);
    const [modalppr, setModalppr] = useState(false);
    const [searchNumero, setSearchNumero] = useState('');
    const [searchIntitule, setSearchIntitule] = useState('');
    const [pprFilter, setPprFilter] = useState('');
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');
    
    const purple = '#6571FE';
    const blue = '#069BD3';
    const green = '#59B44A';
    
    const [suppressAll, setSuppressAll] = useState(false);
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    
    async function callbackDialog(ret) {
        if (ret === true) {
            await suppressProjet(idSelected);
        }
        await setIdSelected(null);
    }
    

    async function create()
    {
        if (props.user.id_budget && props.user.id_budget !== null) {
            let numero = 0
            if (listeProjets.length !== 0) {
                listeProjets.forEach(projet => {
                    numero = projet[2]
                });
            }
            numero++;
            const params = {
                'creationFicheProjet': true,
                'id_user': props.user.id,
                'id_budget': props.user.id_budget,
                'numero_projet': numero,
                'annees': annees
            }
            await axios.post('https://app-slfinance.fr/api/fiches_projets.php', qs.stringify(params))
            .then((result) => {
                if (result.data['status'] === 1) {
                    NotificationManager.success(result.data['status_message'], '', 700);
                    setTimeout(() => window.location = window.location.origin + '/saisie/prospective/ficheprojet/'+result.data.id_projet, 900);
                }
                else {
                    NotificationManager.warning(result.data['status_message'], '', 2000);
                }
            })
        }
    }

    async function suppressProjet(id)
    {
        const params = {
            'suppressProjet': true,
            'id': id
        }
        await axios.post('https://app-slfinance.fr/api/fiches_projets.php', qs.stringify(params))
        .then((result) => {
            if (result.data['status'] === 1) {
                NotificationManager.success(result.data['status_message'], '', 700);
                setTimeout(() => window.location = window.location.href, 900);
            }
            else {
                NotificationManager.warning(result.data['status_message'], '', 2000);
            }
        })
    }


    async function mount()
    {
        console.log(props)
        /* Récupération des projets */
        await axios.post('https://app-slfinance.fr/api/fiches_projets.php', qs.stringify({
            'getFichesProjets': true,
            'id_budget': props.user.id_budget
        }))
        .then((result) => {
            setListeProjets(result.data);
        })
        
        /* Récupération de la liste des tag ppr pour ce budget */
        await axios.post('https://app-slfinance.fr/api/tags_ppr.php', qs.stringify({
            getTags: true,
            id_budget: props.user.id_budget
        }))
        .then((result) => {
            setListeppr(result.data.sort((a, b) => a[0].localeCompare(b[0])));
        })

        /* Recuperation des annees de prospective */
        let prosp_an_deb = ''
        let prosp_an_fin = ''
        await axios.get('https://app-slfinance.fr/api/config_budget.php?id_budget='+props.user.id_budget)
        .then((result) => {
            result.data.forEach(element => {
                if (element[2] === 'prosp_an_deb') {
                    prosp_an_deb = parseInt(element[3])
                }
                if (element[2] === 'prosp_an_fin') {
                    prosp_an_fin = parseInt(element[3])
                }
            });
        }).catch((err) => {console.warn(err)})
        
        if (prosp_an_deb === '' || prosp_an_fin === '')
        {
            await axios.get('https://app-slfinance.fr/api/application.php?access_token=StrategiesLocales')
            .then(async function (res) {
                if (res.data.prosp_an_deb && res.data.prosp_an_fin) {
                    if (prosp_an_deb === '') {
                        prosp_an_deb = parseInt(res.data.prosp_an_deb)
                    }
                    if (prosp_an_fin === '') {
                        prosp_an_fin = parseInt(res.data.prosp_an_fin)
                    }
                }
            })
            .catch((err) => {
                console.warn(err)
            })
        }
        var liste_an = []
        var i = 0
        while (prosp_an_deb <= prosp_an_fin)
        {
            liste_an[i] = parseInt(prosp_an_deb)
            prosp_an_deb++;
            i++;
        }
        await setAnnees(liste_an);
    }

    
    // Récuperation de la liste des fiches projets
    useEffect(() => {
        if (props.user === null) {
            props.getUser()
        }
        else {
            mount();
        }
    }, [props.user])


    // Fonction qui permet de cocher ou décocher les hypotheses choisies.
    // A chaque changement de status, cela demande au serveur s'il peut changer le status de l'hypothese choisie, si le retour est positif,
    // alors ca change la case en checked.
    async function hypotheseChecked(id, h, status)
    {
        const params = {
            'updateProjet': true,
            'projet': listeProjets.find(p => p[0] === id)
        }
        // Mise à jour du champ spécifique
        params.projet[h] = status;
        
        await axios.post('https://app-slfinance.fr/api/fiches_projets.php', qs.stringify(params))
        .then(async (result) => {
            if (result.data['status'] === 1) {
                // Recharger la liste des projets
                await mount();
            }
        })
        .catch((err) => {
            console.warn(err);
            NotificationManager.error('Erreur lors de la mise à jour', '', 2000);
        });
    }

    // Tri avec ordre croissant/décroissant
    const sortBy = (field) => {
        let newOrder = 'asc';
        if (sortField === field && sortOrder === 'asc') {
            newOrder = 'desc';
        }
        setSortField(field);
        setSortOrder(newOrder);
        
        setListeProjets(prev => {
            const copy = Array.isArray(prev) ? [...prev] : [];
            copy.sort((a, b) => {
                let va, vb;
                
                // Index mapping
                const indexMap = {
                    'numero_projet': 2,
                    'intitule': 3,
                    'pol_pub_rat': 7,
                    'montant': 9,
                    'color': 27
                };
                
                const idx = indexMap[field];
                va = a && a[idx] !== undefined && a[idx] !== null ? a[idx] : '';
                vb = b && b[idx] !== undefined && b[idx] !== null ? b[idx] : '';
                
                let comparison = 0;
                // Si nombres
                if (field === 'montant' || field === 'numero_projet') {
                    comparison = parseFloat(va || 0) - parseFloat(vb || 0);
                } else {
                    comparison = ('' + va).toString().localeCompare(('' + vb).toString());
                }
                
                return newOrder === 'asc' ? comparison : -comparison;
            });
            return copy;
        });
    };

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    const filtered = listeProjets.filter(projet => {
        // Filtre PPR
        if (pprFilter && pprFilter !== '') {
            if (projet[7] !== pprFilter) return false;
        }
        // Filtre recherche numéro
        if (searchNumero && searchNumero.trim() !== '') {
            const numero = (projet[2] || '').toString().toLowerCase();
            if (!numero.includes(searchNumero.toLowerCase())) return false;
        }
        // Filtre recherche intitulé (insensible aux accents)
        if (searchIntitule && searchIntitule.trim() !== '') {
            const search = removeAccents(searchIntitule.toLowerCase());
            const intitule = removeAccents((projet[3] || '').toLowerCase());
            if (!intitule.includes(search)) return false;
        }
        // Filtre droits de visualisation
        if (!((projet[34] && projet[34].split(';').includes(props.user.id)) || props.user.id_type_users === '1')) {
            return false;
        }
        return true;
    });


	return (
        <div>
            <Access needConnection={true} type_user={[0]}>
                <Navbar user={props.user} />

                <Dialog
                    setModalVisible={setDialogModalVisible}
                    modalVisible={dialogModalVisible}
                    callbackDialog={callbackDialog}
                    message={"Confirmez la suppression :"}
                />

                <ModalGestionPPR
                    modalVisible={modalppr}
                    setModalVisible={setModalppr}
                    objet={listeppr}
                    setListeppr={setListeppr}
                    user={props.user}
                />


                <div style={{display: 'flex'}}>
                    <div style={{flex: 1, margin: 20, display: 'flex'}}>
                        <div style={{flex: 1, display: 'flex'}}>
                            <p>Pilotage projets</p>
                            <p style={{marginLeft: 5}}>\</p>
                            <p style={{marginLeft: 5, color: purple, fontWeight: 'bold'}}>Saisie des projets</p>
                        </div>
                        <div style={{flex: 1}}>
                            {props.user?
                            <p style={{flex: 1, textAlign: 'center'}}>{props.user.nom_budget}</p>
                            :null}
                        </div>
                        <div style={{flex: 1}}></div>
                    </div>
                </div>

                <div style={{flex: 1, margin: 20, display: 'flex'}}>
                    <div style={{flex: 1}}></div>
                    <button
                        className='shadow-md p-2 rounded-md'
                        style={ongletListeProjets?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                        onClick={() => {
                            setOngletListeProjets(true);
                            setOngletIncidencesFinancieres(false);
                            setOngletSyntheseGantt(false);
                        }}
                    >
                        Liste des projets
                    </button>

                    <button
                        className='shadow-md p-2 rounded-md'
                        style={ongletIncidencesFinancieres?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                        onClick={() => {
                            setOngletListeProjets(false);
                            setOngletIncidencesFinancieres(true);
                            setOngletSyntheseGantt(false);
                        }}
                    >
                        Incidences Financieres
                    </button>

                    <button
                        className='shadow-md p-2 rounded-md'
                        style={ongletSyntheseGantt?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                        onClick={() => {
                            setOngletListeProjets(false);
                            setOngletIncidencesFinancieres(false);
                            setOngletSyntheseGantt(true);
                        }}
                    >
                        Synthèse des projets (GANTT)
                    </button>
                    <div style={{flex: 1}}></div>
                </div>


                {ongletListeProjets?
                <div style={{display: 'flex'}}>

                    <div style={{flex: 1}}></div>

                    {props.user && props.user.droits && props.user.droits.fp_pilotage && props.user.droits.fp_pilotage.includes('M') &&
                    <div>
                        <button
                            className='shadow-md rounded-md'
                            style={{flex: 1, backgroundColor: blue, color: 'white', fontSize: 14, margin: 10}}
                            onClick={() => {
                                setModalppr(true);
                            }}
                        >
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft:10, paddingRight: 10}}>
                                <Add width="12" />
                                <p style={{marginLeft: 5}}>Gérer les politiques publiques</p>
                            </div>
                        </button>
                    </div>
                    }

                    <div style={{flex: 1}}></div>

                    {props.user && props.user.droits && props.user.droits.fp_pilotage && props.user.droits.fp_pilotage.includes('M') &&
                    <div>
                        <button
                            className='shadow-md rounded-md'
                            style={{flex: 1, backgroundColor: green, color: 'white', fontSize: 14, margin: 10}}
                            onClick={() => {
                                create()
                            }}
                        >
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft:10, paddingRight: 10}}>
                                <Add width="12" />
                                <p style={{marginLeft: 5}}>Créer un projet</p>
                            </div>
                        </button>
                    </div>
                    }

                    <div style={{flex: 1}}></div>
                    
                </div>
                :null}

                {ongletListeProjets?
                <>
                {/* Section Filtres */}
                <div style={{margin: '0 25px 25px 25px', padding: 20, backgroundColor: '#f8f9fa', borderRadius: 8, border: '1px solid #e0e0e0'}}>
                    <div style={{display: 'flex', alignItems: 'center', marginBottom: 15}}>
                        <p style={{fontSize: 16, fontWeight: 600, color: '#333', margin: 0}}>Filtres</p>
                        <div style={{flex: 1}}></div>
                        <button
                            className='shadow-sm'
                            style={{
                                padding: '8px 16px',
                                borderRadius: 4,
                                border: '1px solid #ccc',
                                backgroundColor: 'white',
                                fontSize: 13,
                                cursor: 'pointer',
                                color: '#666',
                                transition: 'all 0.2s'
                            }}
                            onClick={() => {
                                setSearchNumero('');
                                setSearchIntitule('');
                                setPprFilter('');
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f0f0f0';
                                e.currentTarget.style.borderColor = '#999';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'white';
                                e.currentTarget.style.borderColor = '#ccc';
                            }}
                        >
                            Réinitialiser les filtres
                        </button>
                    </div>
                    
                    {/* Ligne 1: Recherches */}
                    <div style={{display: 'flex', gap: 15, marginBottom: 15}}>
                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Rechercher par numéro</p>
                            <input
                                type="text"
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14}}
                                placeholder="Numéro de projet..."
                                value={searchNumero}
                                onChange={e => setSearchNumero(e.target.value)}
                            />
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Rechercher par intitulé</p>
                            <input
                                type="text"
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14}}
                                placeholder="Intitulé du projet..."
                                value={searchIntitule}
                                onChange={e => setSearchIntitule(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Ligne 2: Filtre PPR */}
                    <div style={{display: 'flex', gap: 15}}>
                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Politique publique de rattachement</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={pprFilter}
                                onChange={e => setPprFilter(e.target.value)}
                            >
                                <option value=''>Toutes les politiques publiques</option>
                                {listeppr.map((elem, i) => (
                                    <option key={i} value={elem[0]}>{rescueHtml(elem[0])}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                </>
                :null}


                {ongletListeProjets?
                <div style={{margin: 25}}>
                    {(!filtered || filtered.length === 0) ? (
                        <div style={{color: '#666', textAlign: 'center', marginTop: 25}}>Aucun projet pour ce budget</div>
                    ) : (
                        <>
                            <div style={{display: 'flex', padding: '8px 12px', borderBottom: '1px solid #ddd', alignItems: 'center', fontWeight: 600, color: '#333'}}>
                                <div style={{width:30, textAlign:'center'}}></div>
                                <div style={{width:50, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('color')}>
                                    État {sortField === 'color' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:1.5, minWidth:120, cursor:'pointer', display:'flex', alignItems:'center'}} onClick={() => sortBy('numero_projet')}>
                                    Numéro {sortField === 'numero_projet' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2.5, minWidth:0, cursor:'pointer', display:'flex', alignItems:'center'}} onClick={() => sortBy('intitule')}>
                                    Intitulé du projet {sortField === 'intitule' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('pol_pub_rat')}>
                                    Politique publique {sortField === 'pol_pub_rat' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:1.5, textAlign:'right', paddingRight: 15, cursor:'pointer'}} onClick={() => sortBy('montant')}>
                                    Montant {sortField === 'montant' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{width: 90}}>
                                    <div>Hypothèses</div>
                                    <div style={{display:'flex', justifyContent:'space-between', fontSize:12, fontWeight:600}}>
                                        <div style={{width:30, textAlign:'center'}}>H1</div>
                                        <div style={{width:30, textAlign:'center'}}>H2</div>
                                        <div style={{width:30, textAlign:'center'}}>H3</div>
                                    </div>
                                </div>
                            </div>

                            <div style={{display:'flex', flexDirection:'column', gap:8, marginTop:8}}>
                                {filtered.map((projet, i) => (
                                    <div 
                                        key={i} 
                                        style={{display: 'flex', width: '100%', padding: '12px', borderRadius: 6, border: '1px solid #eee', background: 'white', alignItems: 'center', cursor: 'pointer', transition: 'background 0.2s'}}
                                        onClick={() => history.push('/saisie/prospective/ficheprojet/'+projet[0]+'?timestamp='+timestamp)}
                                        onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
                                        onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                                    >
                                        <div style={{width:30, textAlign:'center'}}>
                                            <button onClick={async (e) => {
                                                e.stopPropagation();
                                                await setIdSelected(projet[0]);
                                                setDialogModalVisible(true);
                                            }} style={{border:'none', background:'transparent', cursor:'pointer', padding: '8px 12px'}}>
                                                <Trash width="18" />
                                            </button>
                                        </div>
                                        <div style={{width:50, textAlign:'center'}}>
                                            <div style={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: '50%',
                                                backgroundColor: (projet[27] && projet[27] !== '') ? projet[27] : '#bdc3c7',
                                                margin: '0 auto'
                                            }}></div>
                                        </div>
                                        <div style={{flex:1.5, minWidth:120, fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{rescueHtml(projet[2])}</div>
                                        <div style={{flex:2.5, minWidth:0, fontSize: 14}}>{rescueHtml(projet[3])}</div>
                                        <div style={{flex:2, textAlign:'center', fontSize: 12}}>{projet[7]?rescueHtml(projet[7].replace(/\|/g, ' ')):''}</div>
                                        <div style={{flex:1.5, textAlign:'right', fontSize: 12, paddingRight: 15}}>{projet[9]?addSpace(parseFloat(projet[9]))+' €':''}</div>
                                        <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox" 
                                                checked={projet[24] === "0" ? false : true} 
                                                onChange={() => hypotheseChecked(projet[0], 24, projet[24] === "0"?"1":"0")}
                                                style={{cursor: 'pointer'}}
                                            />
                                        </div>
                                        <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox" 
                                                checked={projet[25] === "0" ? false : true} 
                                                onChange={() => hypotheseChecked(projet[0], 25, projet[25] === "0"?"1":"0")}
                                                style={{cursor: 'pointer'}}
                                            />
                                        </div>
                                        <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox" 
                                                checked={projet[26] === "0" ? false : true} 
                                                onChange={() => hypotheseChecked(projet[0], 26, projet[26] === "0"?"1":"0")}
                                                style={{cursor: 'pointer'}}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
                :null}


                {ongletIncidencesFinancieres?
                <div style={{flex: 1, textAlign: 'center', marginTop: 10, marginLeft: 30, marginRight: 30, marginBottom: 30}}>
                    {props.user !== null && annees.length > 0?
                    <IncidencesFinancieres user={props.user} annees={annees} />
                    :null
                    }
                </div>
                :null}


                {ongletSyntheseGantt?
                <div style={{flex: 1, textAlign: 'center', marginTop: 10, marginLeft: 30, marginRight: 30, marginBottom: 30}}>
                    <GanttSyntheseProjets user={props.user} listeProjets={listeProjets} />
                </div>
                :null}

            </Access>
        </div>
	);
}

export default FichesProjets;
